export class ErrorModel extends Error {
  public code: string;

  constructor(data: { code: string; message: string }) {
    super(data.message);
    this.code = data.code;
  }
}
